<template>
  <div class="grid 2xl:grid-cols-4 xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4" v-if="data && data.length">
    <div v-for="(d, i) in data" :key="i">
      <router-link
        v-if="d.entity_type==1"
        :to="{
          name: 'UserSessionDetails',
          params: { id: d.id },
        }"
      >
        <Card :data="d"/>
      </router-link>
      <router-link
        v-if="d.entity_type==2"
        :to="{
          name: 'UserCourseDetails',
          params: { id: d.id },
        }"
      >
        <Card :data="d"/>
      </router-link>
    </div>
  </div>
  <span class="text-xs text-gray-700" v-else>No data found.</span>
</template>

<script>
import Card from "@/components/card/Card.vue";
export default {
  name: "RecommendedSessionCardList",
  components: {
    Card,
  },
  props: {
    data: {
      type: [Array, Object],
    },
  },
};
</script>